var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ph-compare-main"},[_c('el-backtop'),(_vm.showHeader)?_c('hpheader',{ref:"headerRef"}):_vm._e(),_c('ph-edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }